export default __webpack_public_path__ + "static/media/s-m-profile.68824170.png";